
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mfatMGhjCIaidqBO90YYRq0unvTtVUod2bGsXwg_45tDQ5RYMeta } from "/Users/runner/work/1/s/pages/mfa.vue?macro=true";
import { default as homeYneV8ZRibwmLNd_cgpeNRRPYIRV8Inm2d0CA8gFpZ2YMeta } from "/Users/runner/work/1/s/pages/home.vue?macro=true";
import { default as indexAabEKPAzZffV2s5hKgDTDxiPvlgW0leivUb225eUvTgMeta } from "/Users/runner/work/1/s/pages/index.vue?macro=true";
import { default as old9X0m3za1pW38ozqFr9ln9xQm8oCknKyuy_45BCM2q_45sIkMeta } from "/Users/runner/work/1/s/pages/test/old.vue?macro=true";
import { default as drawhkrru5KWjDGd_45nDcURLt_gwAB32sWllL3w5v4N_geUwMeta } from "/Users/runner/work/1/s/pages/test/draw.vue?macro=true";
import { default as i18nXE4jQHuF65tQ5w6X_fjkMo6fJKTJ1LoT_ga_45Z5FdrLgMeta } from "/Users/runner/work/1/s/pages/test/i18n.vue?macro=true";
import { default as indexIR_aoBFfDgWMsJOiCCZi9aHR7EKMqW6qhElkWUksY4cMeta } from "/Users/runner/work/1/s/pages/test/index.vue?macro=true";
import { default as actionsiBBmtw6y9xKSx44HN6bsqfk0Uuuz0XO9PWkgLwRyvqUMeta } from "/Users/runner/work/1/s/pages/test/actions.vue?macro=true";
import { default as Addressf03QBsc71RZ7ceYHRLDSMEOIsf6dceFeKwrw2edl0sQMeta } from "/Users/runner/work/1/s/pages/test/Address.vue?macro=true";
import { default as expensev0bcEFkOccOk9U0Dabk12bj2kgAgpJC8OANO_45Lz_45PEoMeta } from "/Users/runner/work/1/s/pages/test/expense.vue?macro=true";
import { default as indexPiaOn06DuG6n_cFQ8srHx7vYQ_9LVoL_45BlmkOK3d684Meta } from "/Users/runner/work/1/s/pages/calendar/index.vue?macro=true";
import { default as indexzl__7iTfI4VGBmrIPg6_bqIxo0nkC8LJpwob62QvHZAMeta } from "/Users/runner/work/1/s/pages/expenses/index.vue?macro=true";
import { default as materials0amUY89S___45DjlBSfhJC88ykP7oU8Ac4a5uUnrdcbqYMeta } from "/Users/runner/work/1/s/pages/test/materials.vue?macro=true";
import { default as fileUploadcP_45xcCrQRiPHsZRC4JvUDTgfAO3t1fevim_WbFEX7V4Meta } from "/Users/runner/work/1/s/pages/test/fileUpload.vue?macro=true";
import { default as composablesDomkAXmktYAkz_453JDBnExVgNSSFBDcKTfs2CWirazWgMeta } from "/Users/runner/work/1/s/pages/test/composables.vue?macro=true";
import { default as indexgHKelWFGHI18iWx8lzoBf3imt2oxU1mTEo_xCYv0yn4Meta } from "/Users/runner/work/1/s/pages/worksheets/index.vue?macro=true";
import { default as valid_45inputsYo0NTjr4inniZIqU0pv08IY1rcrOBuDCN_45MI1G7eE_45wMeta } from "/Users/runner/work/1/s/pages/test/valid-inputs.vue?macro=true";
import { default as generic_45selectsWwngByfaBbkoA2blbARb4QBJ5EMLsEIK1j1JaBKL_RwMeta } from "/Users/runner/work/1/s/pages/test/generic-selects.vue?macro=true";
import { default as hourRegistrationvE_NoWhy8L7DTpcQxRXt9dNkv0OU0UB_45T3sQCYKZ8aQMeta } from "/Users/runner/work/1/s/pages/test/hourRegistration.vue?macro=true";
import { default as MaterialLocationPvxYXBWWokpon0htBirlhMY9YLqoSms5jJzfk2k3BGAMeta } from "/Users/runner/work/1/s/pages/test/MaterialLocation.vue?macro=true";
import { default as NativeFileUploadyvFJczUbxOTd5dFkGEMEiqErRxDO_45H46E6sjrkP1R0cMeta } from "/Users/runner/work/1/s/pages/test/NativeFileUpload.vue?macro=true";
import { default as index3e3XBA_45vDnjIVx_t73HsSz5VdBDFMaHao7KTyLR1RfgMeta } from "/Users/runner/work/1/s/pages/hourRegistrations/index.vue?macro=true";
import { default as association_45selectuWRFMnW5rtmVNwgnTsuaexvzaWTRNhK_eWzquWH7N08Meta } from "/Users/runner/work/1/s/pages/test/association-select.vue?macro=true";
import { default as worksheetStopwatchqOA2qon9I8kiCTF0hYPj4yEp_459vIcIgO3zbYOjjwT4YMeta } from "/Users/runner/work/1/s/pages/test/worksheetStopwatch.vue?macro=true";
import { default as indexolCpij7O4_45YwrivVIShZRW1RAPLQjNl9lwVzoN7ABV0Meta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/index.vue?macro=true";
import { default as notesaQXeBMwQobnsSTCbD1OC8AHJDcwHkYhO2mKWOHyuhp0Meta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/notes.vue?macro=true";
import { default as indexbD9JRl6QHVfpI7JvKf1qEv1U2wQ9sNNstAP58p_Wi1QMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/qa/index.vue?macro=true";
import { default as _91schemaId_93mp5zfP_2VSS8IIUR7t7YSw_D5eeUB3EhMiqMVY2d3xUMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/qa/[schemaId].vue?macro=true";
import { default as cartrsKw_NVFQeKrDgDPp2rHjDIxBuDPvWFgh8hEacZzNVIMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/cart.vue?macro=true";
import { default as renth6HWzUbV2ua4cUnw_TLckeSW_ABDa6cxUrzhVyqXnMoMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/rent.vue?macro=true";
import { default as indexLM2xHe5HFc1HMjY8GyShZ6WT3jODFmyaUiyF64p3DqMMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/documents/index.vue?macro=true";
import { default as items4kio0hw6wHY1rB83g5Fqb2XkkVpxB2_dxxmKPlKynFYMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/items.vue?macro=true";
import { default as catalogwgwOQXAb4nejSu2v6VEkBSmeMZX7cCx4tCYz4BrErmsMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/catalog.vue?macro=true";
import { default as hour_45registrationsD5ccdNkwTTXpCO4kLQp9wlKUH54KDGCV_zzQQRK3_wwMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/hour-registrations.vue?macro=true";
import { default as standard_45linessTjmjS2_Xxf70X4wrWRJhsALKM0C6AUK3DK_BxEuXPwMeta } from "/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/standard-lines.vue?macro=true";
export default [
  {
    name: "mfa",
    path: "/mfa",
    component: () => import("/Users/runner/work/1/s/pages/mfa.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/Users/runner/work/1/s/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/runner/work/1/s/pages/index.vue")
  },
  {
    name: "test-old",
    path: "/test/old",
    component: () => import("/Users/runner/work/1/s/pages/test/old.vue")
  },
  {
    name: "test-draw",
    path: "/test/draw",
    component: () => import("/Users/runner/work/1/s/pages/test/draw.vue")
  },
  {
    name: "test-i18n",
    path: "/test/i18n",
    component: () => import("/Users/runner/work/1/s/pages/test/i18n.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/Users/runner/work/1/s/pages/test/index.vue")
  },
  {
    name: "test-actions",
    path: "/test/actions",
    component: () => import("/Users/runner/work/1/s/pages/test/actions.vue")
  },
  {
    name: "test-Address",
    path: "/test/Address",
    component: () => import("/Users/runner/work/1/s/pages/test/Address.vue")
  },
  {
    name: "test-expense",
    path: "/test/expense",
    component: () => import("/Users/runner/work/1/s/pages/test/expense.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/Users/runner/work/1/s/pages/calendar/index.vue")
  },
  {
    name: "expenses",
    path: "/expenses",
    component: () => import("/Users/runner/work/1/s/pages/expenses/index.vue")
  },
  {
    name: "test-materials",
    path: "/test/materials",
    component: () => import("/Users/runner/work/1/s/pages/test/materials.vue")
  },
  {
    name: "test-fileUpload",
    path: "/test/fileUpload",
    component: () => import("/Users/runner/work/1/s/pages/test/fileUpload.vue")
  },
  {
    name: "test-composables",
    path: "/test/composables",
    component: () => import("/Users/runner/work/1/s/pages/test/composables.vue")
  },
  {
    name: "worksheets",
    path: "/worksheets",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/index.vue")
  },
  {
    name: "test-valid-inputs",
    path: "/test/valid-inputs",
    component: () => import("/Users/runner/work/1/s/pages/test/valid-inputs.vue")
  },
  {
    name: "test-generic-selects",
    path: "/test/generic-selects",
    component: () => import("/Users/runner/work/1/s/pages/test/generic-selects.vue")
  },
  {
    name: "test-hourRegistration",
    path: "/test/hourRegistration",
    component: () => import("/Users/runner/work/1/s/pages/test/hourRegistration.vue")
  },
  {
    name: "test-MaterialLocation",
    path: "/test/MaterialLocation",
    component: () => import("/Users/runner/work/1/s/pages/test/MaterialLocation.vue")
  },
  {
    name: "test-NativeFileUpload",
    path: "/test/NativeFileUpload",
    component: () => import("/Users/runner/work/1/s/pages/test/NativeFileUpload.vue")
  },
  {
    name: "hourRegistrations",
    path: "/hourRegistrations",
    component: () => import("/Users/runner/work/1/s/pages/hourRegistrations/index.vue")
  },
  {
    name: "test-association-select",
    path: "/test/association-select",
    component: () => import("/Users/runner/work/1/s/pages/test/association-select.vue")
  },
  {
    name: "test-worksheetStopwatch",
    path: "/test/worksheetStopwatch",
    component: () => import("/Users/runner/work/1/s/pages/test/worksheetStopwatch.vue")
  },
  {
    name: "worksheets-worksheetId",
    path: "/worksheets/:worksheetId()",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/index.vue")
  },
  {
    name: "worksheets-worksheetId-notes",
    path: "/worksheets/:worksheetId()/notes",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/notes.vue")
  },
  {
    name: "worksheets-worksheetId-qa",
    path: "/worksheets/:worksheetId()/qa",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/qa/index.vue")
  },
  {
    name: "worksheets-worksheetId-qa-schemaId",
    path: "/worksheets/:worksheetId()/qa/:schemaId()",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/qa/[schemaId].vue")
  },
  {
    name: "worksheets-worksheetId-materials-cart",
    path: "/worksheets/:worksheetId()/materials/cart",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/cart.vue")
  },
  {
    name: "worksheets-worksheetId-materials-rent",
    path: "/worksheets/:worksheetId()/materials/rent",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/rent.vue")
  },
  {
    name: "worksheets-worksheetId-documents",
    path: "/worksheets/:worksheetId()/documents",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/documents/index.vue")
  },
  {
    name: "worksheets-worksheetId-materials-items",
    path: "/worksheets/:worksheetId()/materials/items",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/items.vue")
  },
  {
    name: "worksheets-worksheetId-materials-catalog",
    path: "/worksheets/:worksheetId()/materials/catalog",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/catalog.vue")
  },
  {
    name: "worksheets-worksheetId-hour-registrations",
    path: "/worksheets/:worksheetId()/hour-registrations",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/hour-registrations.vue")
  },
  {
    name: "worksheets-worksheetId-materials-standard-lines",
    path: "/worksheets/:worksheetId()/materials/standard-lines",
    component: () => import("/Users/runner/work/1/s/pages/worksheets/[worksheetId]/materials/standard-lines.vue")
  }
]